/* eslint-disable camelcase */
import Cookies, { Cookie, CookieSetOptions } from "universal-cookie";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";

const cookies = new Cookies();

export function setCookieToken(key: string, value: Cookie, options?: CookieSetOptions) {
  cookies.set(key, value, { path: "/", ...options });
}
export function removeCookieToken(key: string) {
  cookies.remove(key, { path: "/" });
}

export const getCookieToken = (key: string) => {
  return cookies.get(key);
};

// Check if a cookie exists
export const hasCookieToken = (key: string): boolean => {
  return cookies.get(key) !== undefined; // Returns true if key exists
};

export const formatDate = (date: string) => {
  const today = new Date();
  const createdDate = new Date(date);
  const differenceInTime = today.getTime() - createdDate.getTime();
  const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));

  if (differenceInDays === 0) return "Today";
  if (differenceInDays === 1) return "Yesterday";
  if (differenceInDays === 2) return "2 Days Ago";
  return `${differenceInDays} Days Ago`;
};

export const gptModels = [
  "gpt-4o",
  // "chatgpt-4o-latest",
  "gpt-4o-mini",
  // "o1",
  // "o1-mini",
  // "o3-mini",
  // "o1-preview",
  "gpt-5",
  // "gpt-5-turbo", 
  // "gpt-5-mini",
  // "gpt-5-preview",
  // "gpt-5o",
  // "gpt-5o-mini",
  // "gpt-5o-preview",
];

// Function to decode the JWT
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const decodeToken = (token: string): any => {
  try {
    return jwtDecode(token); // Decode the JWT token
  } catch (error) {
    if (error instanceof Error) {
      toast.error(error.message ?? "An error occurred while decoding the token", {
        className: "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }
  }
};

export interface UserData {
  name: string;
  username: string;
  role: string;
  org_id: number;
  sub: number;
}

export const readFileAsBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file); // Encodes the file as Base64
  });
};

export const copyToClipboard = async (text: string) => {
  console.log(text, "text");
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.top = "0";
  textarea.style.left = "0";
  textarea.style.width = "1px";
  textarea.style.height = "1px";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
  navigator.clipboard
    .writeText(text)
    .then(() => console.log("Copied successfully"))
    .catch((err) => console.error("Clipboard API error:", err));
};

export function copyToClipboardText(string: string) {
  let textarea;
  let result;

  try {
    textarea = document.createElement("textarea");
    textarea.setAttribute("readonly", "true");
    textarea.setAttribute("contenteditable", "true");
    textarea.style.position = "fixed"; // prevent scroll from jumping to the bottom when focus is set.
    textarea.value = string;

    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();

    const range = document.createRange();
    range.selectNodeContents(textarea);

    const sel = window.getSelection();
    sel?.removeAllRanges();
    sel?.addRange(range);

    textarea.setSelectionRange(0, textarea.value.length);
    result = document.execCommand("copy");
  } catch (err) {
    console.error(err);
    result = null;
  } finally {
    if (textarea) {
      document.body.removeChild(textarea);
    }
  }

  // manual copy fallback using prompt
  if (!result) {
    const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    const copyHotkey = isMac ? "⌘C" : "CTRL+C";
    result = prompt(`Press ${copyHotkey}`, string); // eslint-disable-line no-alert
    if (!result) {
      return false;
    }
  }
  return true;
}
